import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-terms-of-service',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.css']
})
export class TermsOfServiceComponent implements OnInit {
  termsContent: SafeHtml = '';
  isLoading = true;
  errorMessage = '';

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.loadTermsOfService();
  }

  loadTermsOfService(): void {
    this.http.get('/assets/terms-of-service.html', { responseType: 'text' })
      .subscribe({
        next: (html: string) => {
          this.termsContent = this.sanitizer.bypassSecurityTrustHtml(html);
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error loading terms of service:', error);
          this.errorMessage = 'Failed to load terms of service. Please try again later.';
          this.isLoading = false;
        }
      });
  }

  goBack(): void {
    window.history.back();
  }
}

